import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  .ant-switch {
    background-color: ${({ theme }) => theme.colors.grayVariations.medium};
  }

  .ant-switch-checked {
    background-color: ${({ theme }) => theme.colors.primary.blue};
  }

  & > div:last-child {
    display: flex;
    & > div:first-child {
      margin-right: 8px;
    }
  }
`;

export const MainContainer = styled.div`
  & > div:nth-child(2) {
    margin-bottom: 24px;
  }

  & > div:last-child {
    margin-top: 24px;
  }
`;

export const SupportTableWrapper = styled.div`
  & > div > div:last-child {
    margin-right: 0;
  }
`;
